import React from "react";

export default function Header() {
  return (
    <div className="section has-text-centered">
      <p className="title is-1 has-text-primary">Would you rather</p>
      <p className="subtitle">What will you choose?</p>
    </div>
  );
}
